import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { WorkbookLog } from "../models/models";
import { IWorkbookQueueEntry } from "./offlineworkbook.service";

@Injectable()
export abstract class IOfflineWorkbookService  {
    abstract queueCreate(logentry: WorkbookLog): Promise<number | unknown[]>;
    abstract queueUpdate(logentry: WorkbookLog): Promise<number | unknown[]>;
    abstract getById(id: string): Promise<IWorkbookQueueEntry | null>;
    abstract queueDelete(logentry: WorkbookLog): Promise<void>;
    abstract getQueueEntries(jobId: string | null): Promise<IWorkbookQueueEntry[]>;
    abstract removeQueuedEntry(entry: IWorkbookQueueEntry): Promise<void>;
    
}
